import {
  Crosshair,
  Gem,
  Lightbulb,
  Mic,
  MousePointerClick,
  Palette,
  Type,
} from "lucide-react";
import {
  BRAND_INSIGHTS_TOPIC_AESTHETIC,
  BRAND_INSIGHTS_TOPIC_ANGLE,
  BRAND_INSIGHTS_TOPIC_COPY,
  BRAND_INSIGHTS_TOPIC_CTA,
  BRAND_INSIGHTS_TOPIC_TONE,
  BRAND_INSIGHTS_TOPIC_VALUE_PROP,
} from "../../../../i18n/keysTranslations";

const DEFAULT_NAMESPACE = "angle";

const NAMESPACE_META = {
  angle: {
    Icon: Crosshair,
    labelKey: BRAND_INSIGHTS_TOPIC_ANGLE,
  },
  copy: {
    Icon: Type,
    labelKey: BRAND_INSIGHTS_TOPIC_COPY,
  },
  cta: {
    Icon: MousePointerClick,
    labelKey: BRAND_INSIGHTS_TOPIC_CTA,
  },
  tone: {
    Icon: Mic,
    labelKey: BRAND_INSIGHTS_TOPIC_TONE,
  },
  aesthetic: {
    Icon: Palette,
    labelKey: BRAND_INSIGHTS_TOPIC_AESTHETIC,
  },
  "value-prop": {
    Icon: Gem,
    labelKey: BRAND_INSIGHTS_TOPIC_VALUE_PROP,
  },
};

export const getTopicNamespace = (topicKey = "") => {
  const namespace = String(topicKey).split(".")[0]?.trim().toLowerCase();
  if (namespace && NAMESPACE_META[namespace]) {
    return namespace;
  }
  return DEFAULT_NAMESPACE;
};

export const getInsightTopicMeta = (topicKey = "") => {
  const namespace = getTopicNamespace(topicKey);
  const meta = NAMESPACE_META[namespace] || NAMESPACE_META[DEFAULT_NAMESPACE];

  return {
    namespace,
    Icon: meta.Icon || Lightbulb,
    labelKey: meta.labelKey,
  };
};
